var rtl_rtlignore_default = {
  "rtl": "dCReh",
  "ltr": "oXfFu"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
